import { Feedback } from "src/models/feedback.model";
import { axiosInstance } from "@/services/axiosInstance";

export const createFeedback = async (
  feedbackData: Partial<Feedback>
): Promise<Feedback> => {
  const response = await axiosInstance.post("/api/feedback", feedbackData);
  return response.data;
};

export const getAllFeedbacks = async (
  page: number,
  pageSize: number
): Promise<{ data: Feedback[]; totalPages: number }> => {
  const response = await axiosInstance.get("/api/feedback", {
    params: {
      page,
      pageSize,
    },
  });
  return response.data;
};
